<template>
    <template v-for="control in controlItems">
        <template v-if="control.type === 'dropdown'">
            <Popper class="hrm_common_chat_action_new" placement="bottom-end">
                <hrm-button :buttonMode="isShowTitle ? 'iconTextButton' : 'iconButton'" :iconSize="control?.iconSize"
                    :buttonPadding="isShowTitle ? '4px 10px' : '0'" buttonSize="28px"
                    :buttonClass="`w-full hrm-tip-tap-button flex items-center ${isShowTitle ? 'justify-start' : 'justify-center'}`"
                    :icon="control.icon" tooltipPosition="top" :tooltipText="control?.tooltip"
                    :title="isShowTitle ? control?.name : ''" :class="{
                        'is-active': checkToolbarState[control.id]?.['is-active'],
                        'is-active-menu': control?.options && control.options.some(opt => checkToolbarState[opt.id]?.['is-active'])
                    }" />
                <template #content="{ close }">
                    <div class="hrm-tiptap-card-menu" :class="control?.dropdownClass">
                        <div class="tiptap-card-heading-menu w-full">
                            <ul class="w-full flex flex-col gap-1">
                                <li v-for="option in control.options">
                                    <hrm-button @click="option?.action" buttonMode="iconTextButton"
                                        :iconSize="option?.iconSize" buttonPadding="0" buttonSize="28px"
                                        buttonClass="hrm-tip-tap-button flex justify-center items-center"
                                        buttonAlign="center" :icon="option.icon" :title="option.name"
                                        :class="{ 'is-active': checkToolbarState[option.id]?.['is-active'] }" />
                                </li>
                            </ul>
                        </div>
                    </div>
                </template>
            </Popper>
        </template>
        <template v-else-if="control.type === 'styleDropDown'">
            <Popper class="hrm_common_chat_action_new">
                <hrm-button :buttonMode="isShowTitle ? 'iconTextButton' : 'iconButton'" :iconSize="control?.iconSize"
                    :buttonPadding="isShowTitle ? '4px 10px' : '0'" buttonSize="28px"
                    buttonClass="hrm-tip-tap-button flex justify-center items-center"
                    :title="isShowTitle ? control?.name : ''" :icon="control.icon" :tooltipText="control?.tooltip"
                    tooltipPosition="top" :class="{
                        'is-active': checkToolbarState[control.id]?.['is-active'],
                        'is-active-menu': control?.options && control.options.some(opt => checkToolbarState[opt.id]?.['is-active'])
                    }" />
                <template #content="{ close }">
                    <div class="hrm-tiptap-card-menu hrm-tiptap-highlight">
                        <div class="tiptap-card-highlight-menu">
                            <div class="w-full flex flex-wrap items-center gap-3">
                                <template v-for="option in control.options">
                                    <label v-if="option.type === 'custom'" :for="control?.styleType"
                                        class="relative flex items-center gap-1 tip-tap-color-picker"
                                        :style="{ backgroundColor: `${tiptapEditor.getAttributes(control?.styleType)?.color || '#ffff00'} !important` }">
                                        <label :for="control?.styleType"
                                            class="tip-tap-color-picker tip-tap-highlight-color-icon"
                                            :style="{ backgroundColor: tiptapEditor.getAttributes(control?.styleType)?.color || '#ffff00' }">
                                            <Icon icon="ic:round-color-lens" width="26" height="26"
                                                :style="{ color: `${getIconColor(tiptapEditor.getAttributes(control?.styleType)?.color || '#ffff00')} !important` }" />
                                        </label>
                                        <span class="hrm_button_tooltip hrm_tooltip_top">
                                            {{ option?.name }}
                                        </span>
                                        <input :id="control?.styleType" class="tip-tap-color-picker" type="color"
                                            @input="option?.action"
                                            :value="tiptapEditor.getAttributes(control?.styleType)?.color || '#ffff00'"
                                            :style="{ backgroundColor: tiptapEditor.getAttributes(control?.styleType)?.color || '#ffff00' }" />
                                    </label>
                                    <hrm-button v-else-if="option.type === 'clearStyle'" @click="option?.action"
                                        buttonMode="iconButton" iconSize="26px" buttonPadding="0" buttonSize="28px"
                                        buttonClass="hrm-tip-tap-button flex justify-center items-center"
                                        buttonAlign="center" :icon="option.icon" :tooltipText="option?.name"
                                        tooltipPosition="top" />
                                    <hrm-button v-else @click="option?.action" buttonMode="iconTextButton"
                                        :icon="!option?.isText ? (checkToolbarState[option.id]?.['is-active'] ? option.icon : null) : null"
                                        :title="option?.isText ? option?.name : option?.fontNameType || null"
                                        :tooltipText="option?.name" buttonPadding="0" buttonSize="30px"
                                        :buttonClass="`hrm-tip-tap-button rounded-full flex items-center justify-center ${control?.buttonClasses} ${option?.className}`"
                                        :class="{ 'is-active': checkToolbarState[option.id]?.['is-active'] }"
                                        tooltipPosition="top"
                                        :style="{ ...(option?.style), width: option?.isText ? '30px' : '30px' }" />
                                </template>
                            </div>
                            <div v-if="control?.id === 'fontSize'" class="mt-2 border-t hrmBorderColor pt-4 mt-4">
                                <p class="dark:text-gray-200 text-gray-600 text-sm font-bold">
                                    Custom Size: {{ tiptapEditor.getAttributes('textStyle')?.fontSize || '16px' }}
                                </p>
                                <input type="range" min="12" max="100" step="2"
                                    class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700 mt-4"
                                    :value="parseInt(tiptapEditor.getAttributes('textStyle')?.fontSize || 16)"
                                    @input="control?.customSizeAction" />
                            </div>
                        </div>
                    </div>
                </template>
            </Popper>
        </template>
        <template v-else-if="control.type === 'userLinks'">
            <Popper class="hrm_common_chat_action_new" placement="bottom-end">
                <hrm-button :buttonMode="isShowTitle ? 'iconTextButton' : 'iconButton'" :iconSize="control?.iconSize"
                    :buttonPadding="isShowTitle ? '4px 10px' : '0'" buttonSize="28px"
                    :buttonClass="`hrm-tip-tap-button w-full flex items-center ${isShowTitle ? 'justify-start' : 'justify-center'}`"
                    :icon="control.icon" :tooltipText="control.tooltip" tooltipPosition="top"
                    :title="isShowTitle ? control?.name : ''" :class="{
                        'is-active': checkToolbarState[control.id]?.['is-active']
                    }" />
                <template #content="{ close }">
                    <div class="bg-white px-1 py-0.5 rounded-lg shadow-md 
                            flex items-center gap-2 hrm-tip-tap-link-popup border hrmBorderColor hrmInputGroup">
                        <input v-model="linkUrl" type="text" placeholder="Enter URL"
                            class="border px-2 py-1 rounded w-40 hrm_input_field hrm-tip-tap-link-input"
                            @keyup.enter="addLink(linkUrl, control?.linkType)" />
                        <hrm-button @click="addLink(linkUrl, control?.linkType)" buttonMode="iconButton" iconSize="18px"
                            buttonPadding="0" buttonSize="28px"
                            buttonClass="hrm-tip-tap-button w-full flex justify-center items-center"
                            buttonAlign="center" icon="mi:enter" tooltipText="Apply" tooltipPosition="top" />

                        <div class="flex items-center gap-0.5" v-if="control?.linkType !== 'youtube'">
                            <hrm-button :href="linkUrl" buttonMode="linkIconButtonA" iconSize="18px" buttonPadding="0"
                                buttonSize="28px" buttonClass="hrm-tip-tap-button flex justify-center items-center"
                                buttonAlign="center" icon="fluent:open-20-filled" tooltipText="Preview"
                                tooltipPosition="top" />
                            <hrm-button @click="addLink(null, control?.linkType)" buttonMode="iconButton"
                                iconSize="18px" buttonPadding="0" buttonSize="28px"
                                buttonClass="hrm-tip-tap-button flex justify-center items-center" buttonAlign="center"
                                icon="tabler:trash-filled" tooltipText="Remove" tooltipPosition="top" />
                        </div>
                    </div>
                </template>
            </Popper>
        </template>
        <template v-else>
            <hrm-button @click="control?.action" :buttonMode="isShowTitle ? 'iconTextButton' : 'iconButton'"
                :iconSize="control?.iconSize" :buttonPadding="isShowTitle ? '4px 10px' : '0'" buttonSize="28px"
                :buttonClass="`hrm-tip-tap-button flex items-center ${isShowTitle ? 'justify-start' : 'justify-center'}`"
                :icon="control.icon" :tooltipText="control?.tooltip" tooltipPosition="top"
                :title="isShowTitle ? control?.name : ''"
                :class="{ 'is-active': checkToolbarState[control.id]?.['is-active'] }"
                :disabled="control?.isDisabled" />
        </template>
    </template>
</template>
<script lang="ts" setup>
import { ref, Ref, inject, computed } from 'vue';
import { Icon } from '@iconify/vue';
import Popper from 'vue3-popper';

import { editorProps, setFontColor } from '../Helpers/editorData';

import { EditorConfigsKey } from '../Helpers/keys';
import type { EditorConfig } from '../Helpers/types';

const props = defineProps(["controlItems", "isShowTitle"])

// Inject with full typing
const editorConfigs = inject(
    EditorConfigsKey,
    ref<EditorConfig>(editorProps)
);

const tiptapEditor = inject<Ref<any>>("tiptapEditor", ref(null));
const tiptapFns = inject<{
    applyMath: (type: 'insert_block' | 'insert_inline') => void;
    removeMath: (type: 'remove_block' | 'remove_inline') => void;
    addTable: () => void;
    deleteTable: () => void;
    addColumnBefore: () => void;
    addColumnAfter: () => void;
    deleteColumn: () => void;
    addRowBefore: () => void;
    addRowAfter: () => void;
    deleteRow: () => void;
    mergeCells: () => void;
    splitCell: () => void;
    helpInAiHelper: (helperText: string) => void;
}>('tiptapFunctions');


// Example local calls
const applyMath = (type: 'insert_block' | 'insert_inline') => tiptapFns?.applyMath(type)
const removeMath = (type: 'remove_block' | 'remove_inline') => tiptapFns?.removeMath(type)

const addTable = () => tiptapFns?.addTable()
const deleteTable = () => tiptapFns?.deleteTable()
const addColumnBefore = () => tiptapFns?.addColumnBefore()
const addColumnAfter = () => tiptapFns?.addColumnAfter()
const deleteColumn = () => tiptapFns?.deleteColumn()
const addRowBefore = () => tiptapFns?.addRowBefore()
const addRowAfter = () => tiptapFns?.addRowAfter()
const deleteRow = () => tiptapFns?.deleteRow()
const mergeCells = () => tiptapFns?.mergeCells()
const splitCell = () => tiptapFns?.splitCell()
const helpInAiHelper = (helperText: string) => tiptapFns?.helpInAiHelper(helperText)

const linkUrl = ref('')
const youtubeLinkUrl = ref('')


const checkToolbarState = computed(() => {
    if (editorConfigs?.value?.isDisabled) return {}

    const headingLevels = [1, 2, 3, 4, 5, 6]
    const listTypes = ['bulletList', 'orderedList', 'taskList']
    const colors = ['#ffffff', '#000000', '#b95074', '#278e5c', '#9c5c37', '#6a2ea2', '#9d8732', '']
    const fontSizes = ['12', '14', '16', '18', '20', '24', '32'];
    const textStyles = ["subScript", "supScript", "blockquote", "codeBlock", "code", "justify", "right", "left", "center", "bold", "italic", "strike", "paragraph", "link"];

    const state: any = {}

    // Dropdown options
    headingLevels.forEach(level => {
        state[`heading-${level}`] = {
            'is-active': tiptapEditor.value?.isActive('heading', { level }),
        }
    })

    listTypes.forEach(type => {
        state[type] = {
            'is-active': tiptapEditor.value?.isActive(type),
        }
    })

    colors.forEach(color => {
        state[`highlight-${color}`] = {
            'is-active': tiptapEditor.value?.isActive('highlight', { color }),
        }
        state[`fontColor-${color}`] = {
            'is-active': tiptapEditor.value?.isActive('textStyle', { color }),
        }
    })

    fontSizes.forEach(size => {
        state[`fontSize-${size}`] = {
            'is-active': tiptapEditor.value?.isActive('textStyle', { fontSize: size + 'px' }),
        };
    });

    textStyles.forEach(style => {
        state[`textStyle-${style}`] = {
            'is-active': tiptapEditor.value?.isActive(style),
        };
    });

    return state
})


const addLink = (url?: string, type?: string) => {
    if (!tiptapEditor.value || editorConfigs?.value?.isDisabled) return
    try {
        if (url) {
            if (type === "link") {
                tiptapEditor.value.chain().focus().extendMarkRange('link').setLink({ href: url }).run()
            } else {
                tiptapEditor.value.chain().focus().setYoutubeVideo({ src: url }).run()
            }
        } else {
            if (type === "link") {
                tiptapEditor.value.chain().focus().extendMarkRange('link').unsetLink().run()
            } else {

            }
        }
        linkUrl.value = ''
    } catch (err) {
        console.error('Failed to toggle link:', err)
    }
}

// Get Icon Color
const getIconColor = (color: string) => {
    return setFontColor(color)
}
</script>
<style>
.tip-tap-color-picker {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    padding: 0;
    display: inline-block;
    cursor: pointer;
}

.tip-tap-color-picker .hrm_button_tooltip {
    display: none;
}

.tip-tap-color-picker:hover .hrm_button_tooltip {
    display: block;
}
</style>